import { BORDER_RADIUS, DESKTOP_SPACING, FONT_SIZE, NATURAL, TERTIARY_PURPLE } from "@/theme";
import { CellProps, HeaderCellProps, RowProps } from "./Table.interface";

import styled from "styled-components";

export const StyledTable = styled.table`
  border: 1px solid ${NATURAL.C};
  border-radius: ${BORDER_RADIUS.LG};
  border-spacing: 0;
  margin: 0;
  min-height: 200px;
  padding: 0;
  table-layout: fixed;
`;

export const StyledTr = styled.tr<RowProps>`
  width: auto;
  cursor: ${({ cursor }) => cursor || 'default'};
  background-color: ${({ backgroundColor }) => backgroundColor || ''};
  color: ${({ color }) => color || ''};

  @media (max-width: 1060px) {
    display: block;
    border-bottom: 1px solid #cacaca;
    position: relative;
  }
`;

export const StyledTh = styled.th<HeaderCellProps>`
  background-color: ${({ backgroundColor }) => backgroundColor || TERTIARY_PURPLE.LIGHTER};
  color: ${NATURAL.I};
  font-size: ${FONT_SIZE.SM};
  max-width: ${({ width }) => width || ''};
  padding: ${DESKTOP_SPACING.XXXL}px;
  text-align: ${({ align }) => align || 'center'};

  :first-child {
    border-radius: ${BORDER_RADIUS.LG} 0 0 0;
  }

  :last-child {
    border-radius: 0 ${BORDER_RADIUS.LG} 0 0;
  }
`;

//color: ${NATURAL.H};

export const StyledTd = styled.td<CellProps>`
  font-size: ${FONT_SIZE.SM};
  max-width: ${({ width }) => width || ''};
  padding: ${DESKTOP_SPACING.XXXL}px;
  text-align: ${({ align }) => align || 'center'};
  text-overflow: ellipsis;
  word-wrap: break-word;

  @media (max-width: 1060px) {
    display: block;
    font-size: 1.1rem;
    text-align: left;
    padding: 10px;
    border: none;
  }
`;

export const StyledThead = styled.thead`
  width: auto;
  color: black;

  @media (max-width: 1060px) {
    display: none;
  }
`;

export const StyledTbody = styled.tbody`
  width: auto;

  ${StyledTd} {
    @media (min-width: 1060px) {
      border-top: 1px solid ${NATURAL.C};
    }
  }
`;
